import { render, staticRenderFns } from "./ReviewAgreement.vue?vue&type=template&id=3099aa78&scoped=true&"
import script from "./ReviewAgreement.vue?vue&type=script&lang=js&"
export * from "./ReviewAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3099aa78",
  null
  
)

export default component.exports